// src/components/iaDashboard/cards/ActiveSessionsCard.jsx
import React from "react";

export default function ActiveSessionsCard({ value, realtimeValue }) {
  const display = realtimeValue ?? value ?? 0;

  return (
    <div className="ia-card ia-card-active">
      <div className="ia-card-header">
        <span className="ia-card-label">Atendimentos ativos</span>
        <span className="ia-card-chip ia-card-chip-live">Ao vivo</span>
      </div>
      <div className="ia-card-value">{display}</div>
      <p className="ia-card-sub">
        Sessões em andamento com operadores ou IA acompanhando.
      </p>
    </div>
  );
}
